import { FunctionComponent, useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from './AccountDashboard.module.scss';
import ServiceCard from '../../../../../components/blocks/ServiceCard/ServiceCard';
import HorizontalCard from '../../../../../components/blocks/HorizontalCard/HorizontalCard';
import { ReactComponent as PeopleIll } from '../../../../../asset/images/ill_people.svg';
import { ReactComponent as RocketIll } from '../../../../../asset/images/rocket_with_clouds.svg';
import { AxiosError } from 'axios';
import { ApiResponseDTO } from '../../../../../dto/api';
import api from '../../../../../api';
import PreloadProductCard from '../../../../../components/blocks/PreloadProductCard/PreloadProductCard';
import RoutesEnum from '../../../../../enums/routes';
import { stringToUserFriendlyURL, truncateString } from '../../../../../utils/stringFormatMethods';
import { UserRoleEnum } from '../../../../../enums/user';
import { getRoleIdByUserRole } from '../../../../../utils/role';
import MetaTags from '../../../../../components/seo/MetaTags/MetaTags';
import JoinForFreeButton from '../../../../../components/buttons/JoinForFreeButton/JoinForFreeButton';
import Grid from '../../../../../components/blocks/Grid/Grid';

interface AccountDashboardProps {}

const AccountDashboard: FunctionComponent<AccountDashboardProps> = () => {
  const [services, setServices] = useState<Array<any>>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // let cacheData = JSON.parse(sessionStorageGetItem(SESSION_STORAGE_KEYS.CACHE_BUILD_SERVICES)!);

    const getServices = async () => {
      try {
        const response = await api.Content.getServicesByCategoryAndStage({
          roleId: getRoleIdByUserRole(Object.keys(UserRoleEnum)[0] as UserRoleEnum),
          disciplineId: null,
          stage: null,
        });
        const responseData = response.data;
        if (responseData.success === true && responseData.data) {
          setServices(responseData.data);
          // sessionStorageSetItem(SESSION_STORAGE_KEYS.CACHE_BUILD_SERVICES, JSON.stringify(responseData.data));
        } else {
          console.error('Error:', responseData.errors);
        }
      } catch (error) {
        const errorObj = error as AxiosError<ApiResponseDTO>;
        const errorData = errorObj.response?.data;
        if (errorData?.errorMessage) {
          console.error(errorData.errorMessage);
        }
        console.error('Error: ', error);
      } finally {
        setLoading(false);
      }
    };

    // if (cacheData) {
    //   setServices(cacheData);
    //   setLoading(false);
    // } else {
    //   getServices();
    // }

    getServices();
  }, []);

  return (
    <div className={styles['dashboard']}>
      <MetaTags title="Account - Dashboard" />

      <div className={classNames(styles['horizontal-card'], styles['schedule-a-call'])}>
        <HorizontalCard style={{ overflow: 'visible' }}>
          <div className={styles['row']}>
            <div className={styles['col']}>
              <p className={classNames(styles['horizontal-card__title-sec'], 'text text--caps text--caps-small')}>
                Get started
              </p>

              <p className={classNames(styles['horizontal-card__title-main'], 'text text--h4')}>Schedule a call</p>

              <p className={classNames(styles['horizontal-card__text'], 'text text--body-2')}>
                Schedule a call to discuss your company, project, or needs otherwise. We're happy to brainstorm with
                you, answer questions, or propose solutions
              </p>

              <JoinForFreeButton className={styles['horizontal-card__button']} />
            </div>

            <div className={styles['col']}>
              <PeopleIll className={styles['horizontal-card__ill']} />
            </div>
          </div>
        </HorizontalCard>
      </div>

      <div className={styles['recommended']}>
        <p className={classNames(styles['recommended__title'], 'text text--caps')}>Suggested for you</p>

        <div className={styles['recommended__list']}>
          <Grid
            itemGroup={
              services && services?.length > 0
                ? services
                    ?.sort(() => 0.5 - Math.random())
                    .slice(0, 4)
                    .map((item, i) => {
                      return (
                        <ServiceCard
                          title={item.name}
                          text={truncateString(item.description, 200)}
                          price={null}
                          link={`/${Object.keys(UserRoleEnum)[0]}/${RoutesEnum.BUILD}/${stringToUserFriendlyURL(
                            item.name
                          )}`}
                          key={item.id}
                          navigateState={{ serviceId: item.id }}
                        />
                      );
                    })
                : [1, 2, 3, 4].map((item, i) => <PreloadProductCard key={i} />)
            }
            itemsInRow={2}
          />
        </div>
      </div>

      <div className={classNames(styles['horizontal-card'], styles['refer-a-friend'])}>
        <HorizontalCard style={{ overflow: 'visible' }}>
          <div className={styles['row']}>
            <div className={styles['col']}>
              <p className={classNames(styles['horizontal-card__title-sec'], 'text text--caps text--caps-small')}>
                Referrers
              </p>

              <p className={classNames(styles['horizontal-card__title-main'], 'text text--h4')}>Refer a friend</p>

              <p className={classNames(styles['horizontal-card__text'], 'text text--body-2')}>
                Refer a friend for 10% of all of their sales for one year.
              </p>
            </div>

            <div className={styles['col']}>
              <RocketIll className={styles['horizontal-card__ill']} style={{ maxWidth: '377px' }} />
            </div>
          </div>
        </HorizontalCard>
      </div>
    </div>
  );
};

export default AccountDashboard;
